import { Check } from "lucide-react";

const ITEMS = ["Framing", "Renovations", "Additions", "Finishing", "Waterproofing"];

const TRUST = [
  "Professional Workmanship",
  "Clear Communication",
  "Residential Construction",
  "Edmonton Based",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-heading text-[15px] font-bold uppercase tracking-[0.3em] text-warm/60">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-bronze" />
      </span>
    ))}
  </div>
);

export const TrustBar = () => (
  <section data-testid="trust-bar" aria-label="Services and trust highlights">
    <div className="overflow-hidden border-y border-warm/10 bg-charcoal py-5">
      <div className="marquee-track">
        <Row />
        <Row />
        <Row />
        <Row />
      </div>
    </div>
    <div className="border-b border-charcoal/10 bg-warm2">
      <div className="container-cando grid grid-cols-1 gap-x-8 gap-y-3 py-7 sm:grid-cols-2 lg:grid-cols-4">
        {TRUST.map((t, i) => (
          <div key={t} data-testid={`trust-item-${i}`} className="flex items-center gap-3">
            <span className="flex h-6 w-6 items-center justify-center bg-charcoal">
              <Check size={13} strokeWidth={3} className="text-bronze" />
            </span>
            <span className="font-heading text-[14px] font-semibold tracking-wide text-ink">{t}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
